import { type Component } from 'solid-js';
import Sandbox from '~/features/sandbox';

// Full width, one pane. Everything the sandbox does is entering rows into
// accounts, and a rail beside it would only hold controls for a thing that has
// no settings — it does not persist, so there is nothing to name, save or pick
// between.
const SandboxPage: Component = () => (
    <div class='flex-1 min-w-0'>
        <Sandbox />
    </div>
);

export default SandboxPage;
